import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  assistantExpanded: false,
  unreadCount: 0,
  activeChatroomId: null,
  isSending: false,
};

export const assistantChatSlice = createSlice({
  name: 'assistantChat',
  initialState,
  reducers: {
    setAssistantExpanded: (state, action) => {
      state.assistantExpanded = Boolean(action.payload);
    },
    toggleAssistantExpanded: (state) => {
      state.assistantExpanded = !state.assistantExpanded;
    },
    setAssistantUnreadCount: (state, action) => {
      state.unreadCount = Math.max(0, Number(action.payload) || 0);
    },
    incrementAssistantUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    decrementAssistantUnreadCount: (state) => {
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },
    resetAssistantUnreadCount: (state) => {
      state.unreadCount = 0;
    },
    setActiveChatroomId: (state, action) => {
      state.activeChatroomId = action.payload;
    },
    setIsSendingAssistantMessage: (state, action) => {
      state.isSending = Boolean(action.payload);
    },
    resetAssistantChatState: (state) => {
      state.assistantExpanded = false;
      state.unreadCount = 0;
      state.activeChatroomId = null;
      state.isSending = false;
    },
  },
});

export const {
  setAssistantExpanded,
  toggleAssistantExpanded,
  setAssistantUnreadCount,
  incrementAssistantUnreadCount,
  decrementAssistantUnreadCount,
  resetAssistantUnreadCount,
  setActiveChatroomId,
  setIsSendingAssistantMessage,
  resetAssistantChatState,
} = assistantChatSlice.actions;

// Selectors
export const selectAssistantChatState = (state) => state.assistantChat;
export const selectAssistantExpanded = (state) => state.assistantChat?.assistantExpanded ?? false;
export const selectAssistantUnreadCount = (state) => state.assistantChat?.unreadCount ?? 0;
export const selectActiveChatroomId = (state) => state.assistantChat?.activeChatroomId ?? null;
export const selectIsSendingAssistantMessage = (state) => state.assistantChat?.isSending ?? false;

export default assistantChatSlice.reducer;
